module.exports = __webpack_public_path__ + "img/Android-icon.c89f9b8d.png";